import api from "./axios";

// Start the user's once-per-lifetime 30-day trial.
// 201 → {subscription_id, is_trial, trial_ends_at, current_period_end, credits_granted}
// 409 → {error: "trial_already_used"}
// 503 → {error: "trial_unavailable"}
export const startTrial = () => api.post("/api/subscriptions/trial/start/");

// Confirm a mandate-required trial after the user returns from
// Cashfree's hosted-auth page. Activates the trial + credits 100 ZC
// if the mandate is authorised. Idempotent — safe to call on every
// page-mount of /signup/mandate-return.
// 200 → {subscription_id, status, is_trial, mandate_authorised,
//        cashfree_state, target_plan_code, trial_ends_at, credits_granted}
// 503 → {error: "provider_unavailable"} (Cashfree transient — retry)
// 400 → {error: "not_a_mandate_trial" | "no_cashfree_mandate" | "gateway_rejected"}
// 409 → {error: "activation_refused"} (terminal sub state)
export const confirmTrialMandate = (subId) =>
  api.post(`/api/subscriptions/trial/confirm/${subId}/`);

// Regenerate the Cashfree mandate session on a stuck PENDING trial.
// Used by MandateReturn.jsx's "Restart authorisation" button when the
// user's hosted-page session expired or they closed the tab. The old
// Cashfree sub is best-effort cancelled; a fresh session_token is
// returned so the SPA can re-open Cashfree's JS SDK checkout.
// trial_ends_at is NOT reset — the original 30-day window still applies.
// 200 → {subscription_id, provider, provider_subscription_id,
//        authorisation_url, session_token, target_plan_code, trial_ends_at}
// 409 → {error: "regenerate_refused"} (sub not PENDING is_trial)
// 503 → {error: "provider_unavailable"}
// 502 → {error: "gateway_error"}
export const regenerateTrialMandate = (subId, { returnUrl, authMethod } = {}) =>
  api.post(`/api/subscriptions/trial/regenerate-mandate/${subId}/`, {
    return_url: returnUrl,
    auth_method: authMethod,
  });
